import Util from "../../util/util";
import useGetter from "./useGetter";
import useSeason from "./useSeason";

export default function useSiteRankings() {
  let season = useSeason();

  if (!season) season = Util.getCurrentSeason();

  const { data: siteRankingsData, query: siteRankingsQuery } = useGetter(
    `/player-lists/${season}/rankings/site`,
    { enabled: !!season, staleTime: 2 * 60 * 60 * 1000 }
  );

  return { siteRankingsData, siteRankingsQuery };
}
